import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { useNotification } from '../../../context/NotificationContext';
import { autoLinkProducts } from '../services/masterProductsApi';

export default function useAutoLink() {
  const [progress, setProgress] = useState(null);
  const { getAccessTokenSilently } = useAuth0();
  const notification = useNotification();

  const autoLinkMutation = useMutation({
    mutationFn: async (retailerId) => {
      const token = await getAccessTokenSilently();
      return autoLinkProducts(token, retailerId);
    },
    onSuccess: (data) => {
      setProgress({
        total: data.total,
        linked: data.linked,
        unmatched: data.total - data.linked,
        completed: true
      });
      notification.success(`Successfully linked ${data.linked} of ${data.total} products!`);
    },
    onError: (error) => {
      notification.error('Failed to auto-link products');
      console.error('Auto-link error:', error);
      setProgress(null);
    }
  });

  const autoLink = async (retailerId) => {
    setProgress({ total: 0, linked: 0, unmatched: 0, completed: false });
    await autoLinkMutation.mutateAsync(retailerId);
  };

  return {
    autoLink,
    progress,
    isLinking: autoLinkMutation.isPending
  };
}
